export default "__VITE_PUBLIC_ASSET__cee91d4c__"